import React from "react";

import { ReactComponent as HiSVG } from "../../assets/hi.svg";
import { ReactComponent as LoSVG } from "../../assets/lo.svg";

import { ReactComponent as ClubSVG } from "../../assets/suits/club.svg";
import { ReactComponent as SpadeSVG } from "../../assets/suits/spade.svg";
import { ReactComponent as DiamondSVG } from "../../assets/suits/diamond.svg";
import { ReactComponent as HeartSVG } from "../../assets/suits/heart.svg";

export const handleCardSymbol = (c) => {
  let cardSymbol = c.cardName.substring(1, c.cardName.length);
  return cardSymbol === "11"
    ? "J"
    : cardSymbol === "12"
    ? "Q"
    : cardSymbol === "13"
    ? "K"
    : cardSymbol === "1"
    ? "A"
    : cardSymbol;
};

export const handleCardSubText = (i, b) => {
  return i + 1 < b.length ? (
    b[i + 1].action === "HI" ? (
      <HiSVG />
    ) : b[i + 1].action === "LO" ? (
      <LoSVG />
    ) : b[i + 1].action === "CHANGE" ? (
      <p>-</p>
    ) : b[i + 1].action === "SAME" ? (
      <p style={{ color: "#ffb000" }}>=</p>
    ) : null
  ) : null;
};

export const handleCardSuit = (c) => {
  let cardSuit = c.cardName.charAt(0);
  switch (cardSuit) {
    case "S":
      return <SpadeSVG />;
    case "C":
      return <ClubSVG />;
    case "D":
      return <DiamondSVG />;
    case "H":
      return <HeartSVG />;
    default:
      break;
  }
};

export const Cards = [
  "C1",
  "C2",
  "C3",
  "C4",
  "C5",
  "C6",
  "C7",
  "C8",
  "C9",
  "C10",
  "C11",
  "C12",
  "C13",
  "D1",
  "D2",
  "D3",
  "D4",
  "D5",
  "D6",
  "D7",
  "D8",
  "D9",
  "D10",
  "D11",
  "D12",
  "D13",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "H7",
  "H8",
  "H9",
  "H10",
  "H11",
  "H12",
  "H13",
  "S1",
  "S2",
  "S3",
  "S4",
  "S5",
  "S6",
  "S7",
  "S8",
  "S9",
  "S10",
  "S11",
  "S12",
  "S13",
];
